import { render, staticRenderFns } from "./assistant.vue?vue&type=template&id=b456279c&scoped=true"
import script from "./assistant.vue?vue&type=script&lang=js"
export * from "./assistant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b456279c",
  null
  
)

export default component.exports